// `useJobs()` — TanStack Query hook backing /app/jobs.
//
// No polling on the list page (CONTEXT.md decision — polling is per-job
// on the detail page). The list refreshes on focus (TanStack default) and
// on detail-page invalidate when a job transitions to a terminal state.
//
// staleTime 10s — allows back-navigation from detail page to feel instant
// while still refetching often enough that the list reflects newly-spawned
// jobs from the email-poll path within ~10s of return-to-tab.
//
// Pitfall 14 (StrictMode dev double-mount): TanStack Query dedupes by
// queryKey, so the dev double-mount produces one network request per
// ['jobs'] key, not two. Plan 07-04 locks this contract with a test.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchJobs } from '@/lib/api';
import type { JobListDTO } from '@/types/db';

export function useJobs(): UseQueryResult<JobListDTO[], Error> {
  return useQuery<JobListDTO[], Error>({
    queryKey: ['jobs'],
    queryFn: ({ signal }) => fetchJobs(signal),
    staleTime: 10_000,
  });
}
